import AxiosConfig from '../utils/AxiosConfig';
import PlatformBridge from '../utils/PlatformBridge';

class SitesService {
  /**
   * Obtener campos editables según el template
   * GET /sites/config/editable-fields
   */
  async getEditableFields() {
    try {
      console.log('🔵 [SitesService] GET /sites/config/editable-fields - Request');
      console.log('🔵 [SitesService] Request details:', {
        url: '/sites/config/editable-fields',
        empresaId: localStorage.getItem('empresaId'),
        hasToken: Boolean(await PlatformBridge.getToken('accessToken'))
      });
      const response = await AxiosConfig.get('/sites/config/editable-fields');
      console.log('✅ [SitesService] GET /sites/config/editable-fields - Response:', {
        status: response.status,
        statusText: response.statusText,
        data: response.data,
        headers: response.headers
      });
      // El backend devuelve { error: false, status_code: 200, data: { templateId, configurableFields, fixedFields } }
      return response.data?.data || response.data;
    } catch (error) {
      console.error('❌ [SitesService] GET /sites/config/editable-fields - Error:', {
        message: error.message,
        code: error.code,
        response: {
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
          headers: error.response?.headers
        },
        request: {
          url: error.config?.url,
          method: error.config?.method,
          headers: error.config?.headers
        }
      });
      throw error;
    }
  }

  /**
   * Obtener configuración actual del sitio (dashboard)
   * GET /sites/config/admin
   */
  async getSiteConfig() {
    try {
      console.log('🔵 [SitesService] GET /sites/config/admin - Request');
      console.log('🔵 [SitesService] Request details:', {
        url: '/sites/config/admin',
        empresaId: localStorage.getItem('empresaId'),
        hasToken: Boolean(await PlatformBridge.getToken('accessToken'))
      });
      const response = await AxiosConfig.get('/sites/config/admin');
      console.log('✅ [SitesService] GET /sites/config/admin - Response:', {
        status: response.status,
        statusText: response.statusText,
        data: response.data,
        headers: response.headers
      });
      // El backend devuelve { error: false, status_code: 200, data: { metadata, siteConfig, theme } }
      return response.data?.data || response.data;
    } catch (error) {
      console.error('❌ [SitesService] GET /sites/config - Error:', {
        message: error.message,
        code: error.code,
        response: {
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
          headers: error.response?.headers
        },
        request: {
          url: error.config?.url,
          method: error.config?.method,
          headers: error.config?.headers
        }
      });
      throw error;
    }
  }

  /**
   * Actualizar un campo específico
   * PATCH /sites/config/field/{fieldPath}
   * Body: valor JSON válido (ej: "Mi Empresa" para string)
   */
  async updateField(fieldPath, value) {
    try {
      console.log('[SitesService] PATCH /sites/config/field/' + fieldPath + ' - Request:', value);
      const response = await AxiosConfig.patch(`/sites/config/field/${fieldPath}`, value);
      console.log('[SitesService] PATCH /sites/config/field/' + fieldPath + ' - Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[SitesService] PATCH /sites/config/field/' + fieldPath + ' - Error:', error);
      console.error('[SitesService] PATCH /sites/config/field/' + fieldPath + ' - Error Response:', error.response?.data);
      throw error;
    }
  }

  /**
   * Actualizar múltiples campos
   * PUT /sites/config/values
   * Body: { "siteConfig.company.name": "\"valor\"", ... }
   */
  async updateFields(updates) {
    try {
      console.log('🔵 [SitesService] PUT /sites/config/values - Request:', {
        url: '/sites/config/values',
        updates: updates,
        empresaId: localStorage.getItem('empresaId'),
        hasToken: Boolean(await PlatformBridge.getToken('accessToken'))
      });
      const response = await AxiosConfig.put('/sites/config/values', updates);
      console.log('✅ [SitesService] PUT /sites/config/values - Response:', {
        status: response.status,
        statusText: response.statusText,
        data: response.data,
        headers: response.headers
      });
      return response.data;
    } catch (error) {
      console.error('❌ [SitesService] PUT /sites/config/values - Error:', {
        message: error.message,
        code: error.code,
        response: {
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
          headers: error.response?.headers
        },
        request: {
          url: error.config?.url,
          method: error.config?.method,
          headers: error.config?.headers,
          data: error.config?.data
        }
      });
      throw error;
    }
  }

  /**
   * Resetear un campo al valor por defecto
   * DELETE /sites/config/field/{fieldPath}
   */
  async resetField(fieldPath) {
    try {
      console.log('[SitesService] DELETE /sites/config/field/' + fieldPath + ' - Request');
      const response = await AxiosConfig.delete(`/sites/config/field/${fieldPath}`);
      console.log('[SitesService] DELETE /sites/config/field/' + fieldPath + ' - Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[SitesService] DELETE /sites/config/field/' + fieldPath + ' - Error:', error);
      console.error('[SitesService] DELETE /sites/config/field/' + fieldPath + ' - Error Response:', error.response?.data);
      throw error;
    }
  }

  /**
   * Obtener configuración draft (en edición)
   * GET /sites/config/draft
   */
  async getDraftConfig() {
    try {
      console.log('🔵 [SitesService] GET /sites/config/draft - Request');
      const response = await AxiosConfig.get('/sites/config/draft');
      console.log('✅ [SitesService] GET /sites/config/draft - Response:', response.data);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('❌ [SitesService] GET /sites/config/draft - Error:', error);
      throw error;
    }
  }

  /**
   * Publicar la configuración draft como nueva versión
   * POST /sites/config/publish
   */
  async publishConfig() {
    try {
      console.log('🔵 [SitesService] POST /sites/config/publish - Request');
      const response = await AxiosConfig.post('/sites/config/publish');
      console.log('✅ [SitesService] POST /sites/config/publish - Response:', response.data);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('❌ [SitesService] POST /sites/config/publish - Error:', error);
      throw error;
    }
  }

  /**
   * Obtener todas las versiones/publicaciones
   * GET /sites/config/versions
   */
  async getVersions() {
    try {
      console.log('🔵 [SitesService] GET /sites/config/versions - Request');
      const response = await AxiosConfig.get('/sites/config/versions');
      console.log('✅ [SitesService] GET /sites/config/versions - Response:', response.data);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('❌ [SitesService] GET /sites/config/versions - Error:', error);
      throw error;
    }
  }

  /**
   * Activar una versión específica (rollback)
   * PUT /sites/config/versions/{versionId}/activate
   */
  async activateVersion(versionId) {
    try {
      console.log('🔵 [SitesService] PUT /sites/config/versions/' + versionId + '/activate - Request');
      const response = await AxiosConfig.put(`/sites/config/versions/${versionId}/activate`);
      console.log('✅ [SitesService] PUT /sites/config/versions/' + versionId + '/activate - Response:', response.data);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('❌ [SitesService] PUT /sites/config/versions/' + versionId + '/activate - Error:', error);
      throw error;
    }
  }

  // Métodos legacy (mantener por compatibilidad si es necesario)
  /**
   * Actualizar configuración completa del sitio
   * PUT /sites/config
   * Body: { siteConfig: {...}, theme: {...}, metadata: {...} }
   * @deprecated Usar updateFields en su lugar
   */
  async updateSiteConfig(configData) {
    try {
      console.log('[SitesService] PUT /sites/config - Request:', configData);
      const response = await AxiosConfig.put('/sites/config', configData);
      console.log('[SitesService] PUT /sites/config - Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[SitesService] PUT /sites/config - Error:', error);
      console.error('[SitesService] PUT /sites/config - Error Response:', error.response?.data);
      throw error;
    }
  }

  // ============ PRODUCTOS DEL SITIO ============

  /**
   * Obtener todos los productos del sitio
   * GET /sites/products/admin?categoryId=&tagId=&search=
   */
  async getSiteProducts(categoryId = null, tagId = null, search = null) {
    try {
      const params = new URLSearchParams();
      if (categoryId) params.append('categoryId', categoryId);
      if (tagId) params.append('tagId', tagId);
      if (search) params.append('search', search);
      
      const url = `/sites/products/admin${params.toString() ? '?' + params.toString() : ''}`;
      const response = await AxiosConfig.get(url);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error fetching site products:', error);
      throw error;
    }
  }

  /**
   * Obtener producto por ID
   * GET /sites/products/admin/{id}
   */
  async getSiteProductById(id) {
    try {
      const response = await AxiosConfig.get(`/sites/products/admin/${id}`);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error fetching site product:', error);
      throw error;
    }
  }

  /**
   * Crear producto del sitio
   * POST /sites/products/admin
   */
  async createSiteProduct(productData) {
    try {
      const response = await AxiosConfig.post('/sites/products/admin', productData);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error creating site product:', error);
      throw error;
    }
  }

  /**
   * Actualizar producto del sitio
   * PUT /sites/products/admin/{id}
   */
  async updateSiteProduct(id, productData) {
    try {
      const response = await AxiosConfig.put(`/sites/products/admin/${id}`, productData);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error updating site product:', error);
      throw error;
    }
  }

  /**
   * Obtener visibilidad por sucursal para un producto del sitio
   * GET /sites/products/admin/{id}/locations?locationIds=1,2,3
   */
  async getSiteProductLocations(id, locationIds = []) {
    try {
      const params = new URLSearchParams();
      if (Array.isArray(locationIds) && locationIds.length > 0) {
        params.append('locationIds', locationIds.join(','));
      }
      const url = `/sites/products/admin/${id}/locations${params.toString() ? '?' + params.toString() : ''}`;
      const response = await AxiosConfig.get(url);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error fetching site product locations:', error);
      throw error;
    }
  }

  /**
   * Actualizar visibilidad por sucursal para un producto del sitio
   * PUT /sites/products/admin/{id}/locations/{locationId}
   */
  async updateSiteProductLocation(id, locationId, enabled) {
    try {
      const response = await AxiosConfig.put(`/sites/products/admin/${id}/locations/${locationId}`, { enabled });
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error updating site product location:', error);
      throw error;
    }
  }

  /**
   * Eliminar producto del sitio
   * DELETE /sites/products/admin/{id}
   */
  async deleteSiteProduct(id) {
    try {
      const response = await AxiosConfig.delete(`/sites/products/admin/${id}`);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error deleting site product:', error);
      throw error;
    }
  }

  /**
   * Obtener productos disponibles para asociar
   * GET /sites/products/admin/available-products
   */
  async getAvailableProducts() {
    try {
      const response = await AxiosConfig.get('/sites/products/admin/available-products');
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error fetching available products:', error);
      throw error;
    }
  }

  // ============ CATEGORÍAS ============

  /**
   * Obtener todas las categorías (dashboard)
   * GET /sites/products/categories/admin
   */
  async getSiteProductCategories() {
    try {
      const response = await AxiosConfig.get('/sites/products/categories/admin');
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error fetching categories:', error);
      throw error;
    }
  }

  /**
   * Obtener categoría por ID
   * GET /sites/products/categories/{id}
   */
  async getSiteProductCategoryById(id) {
    try {
      const response = await AxiosConfig.get(`/sites/products/categories/${id}`);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error fetching category:', error);
      throw error;
    }
  }

  /**
   * Crear categoría
   * POST /sites/products/categories
   */
  async createSiteProductCategory(categoryData) {
    try {
      const response = await AxiosConfig.post('/sites/products/categories', categoryData);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error creating category:', error);
      throw error;
    }
  }

  /**
   * Actualizar categoría
   * PUT /sites/products/categories/{id}
   */
  async updateSiteProductCategory(id, categoryData) {
    try {
      const response = await AxiosConfig.put(`/sites/products/categories/${id}`, categoryData);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error updating category:', error);
      throw error;
    }
  }

  /**
   * Eliminar categoría
   * DELETE /sites/products/categories/{id}
   */
  async deleteSiteProductCategory(id) {
    try {
      const response = await AxiosConfig.delete(`/sites/products/categories/${id}`);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error deleting category:', error);
      throw error;
    }
  }

  // ============ TAGS ============

  /**
   * Obtener todos los tags (dashboard)
   * GET /sites/products/tags/admin
   */
  async getSiteProductTags() {
    try {
      const response = await AxiosConfig.get('/sites/products/tags/admin');
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error fetching tags:', error);
      throw error;
    }
  }

  /**
   * Obtener tag por ID
   * GET /sites/products/tags/{id}
   */
  async getSiteProductTagById(id) {
    try {
      const response = await AxiosConfig.get(`/sites/products/tags/${id}`);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error fetching tag:', error);
      throw error;
    }
  }

  /**
   * Crear tag
   * POST /sites/products/tags
   */
  async createSiteProductTag(tagData) {
    try {
      const response = await AxiosConfig.post('/sites/products/tags', tagData);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error creating tag:', error);
      throw error;
    }
  }

  /**
   * Actualizar tag
   * PUT /sites/products/tags/{id}
   */
  async updateSiteProductTag(id, tagData) {
    try {
      const response = await AxiosConfig.put(`/sites/products/tags/${id}`, tagData);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error updating tag:', error);
      throw error;
    }
  }

  /**
   * Eliminar tag
   * DELETE /sites/products/tags/{id}
   */
  async deleteSiteProductTag(id) {
    try {
      const response = await AxiosConfig.delete(`/sites/products/tags/${id}`);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error deleting tag:', error);
      throw error;
    }
  }

  // ============ NOTIFICACIONES ============

  async getSiteNotificationEmailConfig() {
    try {
      const response = await AxiosConfig.get('/settings/site-notification-email-config');
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error fetching notification email config:', error);
      throw error;
    }
  }

  async updateSiteNotificationEmailConfig(config) {
    try {
      const response = await AxiosConfig.post('/settings/site-notification-email-config', config);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error updating notification email config:', error);
      throw error;
    }
  }

  /**
   * Obtener todas las notificaciones (filtradas por permisos del usuario)
   * GET /notifications?type=&isRead=&page=&pageSize=&search=
   * Accesible para todos los usuarios autenticados
   */
  async getNotifications(type = null, isRead = null, page = 1, pageSize = 10, search = null) {
    try {
      const params = new URLSearchParams();
      if (type) params.append('type', type);
      if (isRead !== null) params.append('isRead', isRead);
      params.append('page', page);
      params.append('pageSize', pageSize);
      if (search) params.append('search', search);
      
      const url = `/notifications${params.toString() ? '?' + params.toString() : ''}`;
      const response = await AxiosConfig.get(url);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error fetching notifications:', error);
      throw error;
    }
  }

  /**
   * Obtener todas las notificaciones (endpoint antiguo con MANAGE_SITES)
   * GET /sites/notifications?type=&isRead=&page=&pageSize=
   * @deprecated Usar getNotifications() en su lugar
   */
  async getSiteNotifications(type = null, isRead = null, page = 1, pageSize = 10) {
    try {
      const params = new URLSearchParams();
      if (type) params.append('type', type);
      if (isRead !== null) params.append('isRead', isRead);
      params.append('page', page);
      params.append('pageSize', pageSize);
      
      const url = `/sites/notifications${params.toString() ? '?' + params.toString() : ''}`;
      const response = await AxiosConfig.get(url);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error fetching site notifications:', error);
      throw error;
    }
  }

  /**
   * Obtener notificación por ID
   * GET /sites/notifications/{id}
   */
  async getNotificationById(id) {
    try {
      const response = await AxiosConfig.get(`/sites/notifications/${id}`);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error fetching notification:', error);
      throw error;
    }
  }

  /**
   * Marcar notificación como leída
   * PUT /notifications/{id}/read
   * Accesible para todos los usuarios autenticados
   */
  async markNotificationAsRead(id) {
    try {
      const response = await AxiosConfig.put(`/notifications/${id}/read`);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error marking notification as read:', error);
      throw error;
    }
  }

  /**
   * Sucursales donde esta persona tiene conteo de stock pendiente hoy (aviso calculado para la campanita).
   * GET /notifications/stock-count
   */
  async getStockCountNotifications() {
    try {
      const response = await AxiosConfig.get('/notifications/stock-count');
      const data = response.data?.data ?? response.data;
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error('[SitesService] Error fetching stock count notifications:', error);
      throw error;
    }
  }

  /**
   * Pedidos web pendientes de despacho que ESTE usuario todavía no confirmó (por sesión/usuario,
   * no global como isRead): es lo que dispara el cartel de "Nuevo pedido web".
   * GET /notifications/pending-order-acknowledgements
   */
  async getPendingOrderAcknowledgements() {
    try {
      const response = await AxiosConfig.get('/notifications/pending-order-acknowledgements');
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error fetching pending order acknowledgements:', error);
      throw error;
    }
  }

  /**
   * Confirma un pedido web para ESTE usuario puntual (no marca isRead global: otras sesiones
   * con acceso a la sucursal lo siguen viendo pendiente hasta que cada una lo confirme).
   * POST /notifications/{id}/acknowledge
   */
  async acknowledgeOrderNotification(id) {
    try {
      const response = await AxiosConfig.post(`/notifications/${id}/acknowledge`);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error acknowledging order notification:', error);
      throw error;
    }
  }

  /**
   * Marcar todas las notificaciones como leídas
   * PUT /notifications/read-all
   * Requiere MANAGE_SITES
   */
  async markAllNotificationsAsRead() {
    try {
      const response = await AxiosConfig.put('/notifications/read-all');
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error marking all notifications as read:', error);
      throw error;
    }
  }

  /**
   * Obtener conteo de notificaciones no leídas (filtradas por permisos)
   * GET /notifications/unread-count?type=
   * Accesible para todos los usuarios autenticados
   */
  async getUnreadCount(type = null) {
    try {
      const params = new URLSearchParams();
      if (type) params.append('type', type);
      
      const url = `/notifications/unread-count${params.toString() ? '?' + params.toString() : ''}`;
      const response = await AxiosConfig.get(url);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error fetching unread count:', error);
      throw error;
    }
  }

  /**
   * Eliminar notificación
   * DELETE /sites/notifications/{id}
   */
  async deleteNotification(id) {
    try {
      const response = await AxiosConfig.delete(`/sites/notifications/${id}`);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('[SitesService] Error deleting notification:', error);
      throw error;
    }
  }

  // ============ PREVIEW ============

  /**
   * Obtener token de preview para previsualizar el sitio
   * GET /sites/config/preview-token
   */
  async getPreviewToken() {
    try {
      console.log('🔵 [SitesService] GET /sites/config/preview-token - Request');
      const response = await AxiosConfig.get('/sites/config/preview-token');
      console.log('✅ [SitesService] GET /sites/config/preview-token - Response:', response.data);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('❌ [SitesService] GET /sites/config/preview-token - Error:', error);
      throw error;
    }
  }

  /**
   * Listar imágenes y carpetas
   * GET /sites/images?path=...
   */
  async listImages(path = '') {
    try {
      const params = path ? { path } : {};
      const response = await AxiosConfig.get('/sites/images', { params });
      return response.data?.data || response.data;
    } catch (error) {
      console.error('❌ [SitesService] GET /sites/images - Error:', error);
      throw error;
    }
  }

  /**
   * Obtener URL de previsualización para una imagen (path S3 o relativo).
   * GET /sites/images/preview-url?path=...
   * El path puede contener espacios (ej. "sites/images/Carrusel portada/archivo.png").
   */
  async getImagePreviewUrl(path) {
    if (!path || typeof path !== 'string') return null;
    try {
      const response = await AxiosConfig.get('/sites/images/preview-url', {
        params: { path },
        paramsSerializer: (params) => {
          return Object.entries(params)
            .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
            .join('&');
        }
      });
      const data = response.data?.data ?? response.data;
      return (data && data.url) ? data.url : null;
    } catch (error) {
      console.warn('[SitesService] getImagePreviewUrl failed for path:', path?.substring?.(0, 50), error?.response?.status, error?.message);
      return null;
    }
  }

  /**
   * Crear carpeta
   * POST /sites/images/folder
   */
  async createFolder(folderName, parentPath = '') {
    try {
      const response = await AxiosConfig.post('/sites/images/folder', {
        folderName,
        parentPath
      });
      return response.data?.data || response.data;
    } catch (error) {
      console.error('❌ [SitesService] POST /sites/images/folder - Error:', error);
      throw error;
    }
  }

  /**
   * Subir imagen
   * POST /sites/images/upload?path=...
   */
  async uploadImage(file, parentPath = '') {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const params = parentPath ? { path: parentPath } : {};
      const response = await AxiosConfig.post('/sites/images/upload', formData, {
        params,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data?.data || response.data;
    } catch (error) {
      console.error('❌ [SitesService] POST /sites/images/upload - Error:', error);
      throw error;
    }
  }

  /**
   * Eliminar imagen o carpeta
   * DELETE /sites/images?path=...
   */
  async deleteImage(path) {
    try {
      const response = await AxiosConfig.delete('/sites/images', {
        params: { path }
      });
      return response.data?.data || response.data;
    } catch (error) {
      console.error('❌ [SitesService] DELETE /sites/images - Error:', error);
      throw error;
    }
  }

  // ============ TARIFAS DE ENVÍO ============

  /**
   * Listar tarifas de envío por sucursal
   * GET /sites/shipping/rates?locationId=
   */
  async getShippingRates(locationId) {
    const response = await AxiosConfig.get('/sites/shipping/rates', {
      params: { locationId }
    });
    return response.data?.data ?? response.data ?? [];
  }

  /**
   * Obtener detalle de una tarifa por rango de distancia.
   * GET /sites/shipping/rates/:id
   */
  async getShippingRateById(id) {
    const response = await AxiosConfig.get(`/sites/shipping/rates/${id}`);
    return response.data?.data ?? response.data;
  }

  /**
   * Crear tarifa de envío
   * POST /sites/shipping/rates
   */
  async createShippingRate(body) {
    const response = await AxiosConfig.post('/sites/shipping/rates', body);
    return response.data?.data ?? response.data;
  }

  /**
   * Actualizar tarifa de envío
   * PUT /sites/shipping/rates/:id
   */
  async updateShippingRate(id, body) {
    const response = await AxiosConfig.put(`/sites/shipping/rates/${id}`, body);
    return response.data?.data ?? response.data;
  }

  /**
   * Eliminar tarifa de envío
   * DELETE /sites/shipping/rates/:id
   */
  async deleteShippingRate(id) {
    await AxiosConfig.delete(`/sites/shipping/rates/${id}`);
  }

  /**
   * Obtener estado de envío por sucursal.
   * Devuelve { isOpen, pickupAddress, pickupReference }.
   * GET /sites/shipping/location-schedules?locationId=
   */
  async getLocationSchedules(locationId) {
    const response = await AxiosConfig.get('/sites/shipping/location-schedules', {
      params: { locationId }
    });
    const raw = response.data?.data ?? response.data;
    if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
      return {
        isOpen: raw.isOpen !== false,
        pickupAddress: raw.pickupAddress ?? '',
        pickupReference: raw.pickupReference ?? '',
        schedules: Array.isArray(raw.schedules) ? raw.schedules : [],
        manualOverrideOpen: raw.manualOverrideOpen ?? null,
        manualOverrideUntil: raw.manualOverrideUntil ?? null,
      };
    }
    return { isOpen: true, pickupAddress: '', pickupReference: '', schedules: [], manualOverrideOpen: null, manualOverrideUntil: null };
  }

  /**
   * Guardar estado/envío por sucursal.
   * PUT /sites/shipping/location-schedules
   */
  async updateLocationSchedules(
    locationId,
    isOpen = null,
    pickupAddress = null,
    pickupReference = null,
    schedules = null,
    manualOverrideOpen = null,
    manualOverrideUntil = null,
    clearManualOverride = false
  ) {
    const body = { locationId };
    if (isOpen !== null && isOpen !== undefined) body.isOpen = isOpen;
    if (pickupAddress !== null && pickupAddress !== undefined) body.pickupAddress = pickupAddress;
    if (pickupReference !== null && pickupReference !== undefined) body.pickupReference = pickupReference;
    if (schedules !== null && schedules !== undefined) body.schedules = schedules;
    if (manualOverrideOpen !== null && manualOverrideOpen !== undefined) body.manualOverrideOpen = manualOverrideOpen;
    if (manualOverrideUntil !== null && manualOverrideUntil !== undefined) body.manualOverrideUntil = manualOverrideUntil;
    if (clearManualOverride === true) body.clearManualOverride = true;
    const response = await AxiosConfig.put('/sites/shipping/location-schedules', body);
    return response.data?.data ?? response.data;
  }
}

export default new SitesService();
